module.exports = __webpack_public_path__ + "static/xorn-e075fdc9df18f4509ee6f0c954f10fd9.jpg";